import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

function AddAdmin() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone2, setPhone2] = useState("");
  const [email, setEmail] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [mandalDetailsId, setMandalDetailsId] = useState("");
  const [mandals, setMandals] = useState([]);
  const [selectedMandal, setSelectedMandal] = useState("");
  const [isVisible] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location?.pathname || "";
  const { id } = location?.state || {};

  console.log(`id: ${id}`);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SuperAdmin") {
      navigate("/");
    }
  }, [navigate]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file) {
      setImagePreview(URL.createObjectURL(file));
      const fileName = file.name;
      e.target.nextElementSibling.innerText = fileName;
    } else {
      setImagePreview(null);
      e.target.nextElementSibling.innerText = "Choose file";
    }
  };

  useEffect(() => {
    const fetchMandals = async () => {
      try {
        const response = await axios.get(
          `${apiURL}/MandalDetails/GetPublicList`
        );
        setMandals(response.data.data);
      } catch (error) {
        console.error("Error fetching mandals:", error);
      }
    };

    fetchMandals();
  }, []);

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedMandal(selectedValue);
    setMandalDetailsId(selectedValue); // Ensure MandalDetailsId is set correctly
  };

  const handleSubmit = (e) => {
    setLoaded(true);
    e.preventDefault();

    if (!/^\d{10}$/.test(phone)) {
      setLoaded(false);
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    let data = new FormData();
    data.append("mandalDetailsId", mandalDetailsId);
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    data.append("userName", userName);
    data.append("password", password);
    data.append("Address", address);
    data.append("contactNo", phone);
    data.append("contactNo1", phone1 || "");
    data.append("contactNo2", phone2 || "");
    data.append("emailId", email || "");
    data.append("isVisible", isVisible);
    data.append("type", "Admin");
    data.append("AttendenceStatus", false);
    if (image) {
      data.append("Image", image);
    }

    let config = {
      method: "post",
      url: `${apiURL}/User/Create`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoaded(false);
        setFirstName("");
        setLastName("");
        setUserName("");
        setPassword("");
        setAddress("");
        setPhone("");
        setPhone1("");
        setPhone2("");
        setEmail("");
        setImage(null);
        setImagePreview(null);

        const fileInput = document.getElementById("photoUpload");
        if (fileInput) {
          fileInput.value = "";
          const label = fileInput.nextElementSibling;

          if (label) {
            label.innerText = "Choose file (417 X 530 - 1MB)";
          }
        }
        toast.success(response.data.message);

        if (currentPath === "/add-admin") {
          const timeOutId = setTimeout(() => {
            if (currentPath === "/add-admin") {
              navigate("/manage-admin", { state: { id: id } });
            }
          }, 3000);
          return () => clearTimeout(timeOutId);
        }
      })
      .catch((error) => {
        setLoaded(false);
        toast.error(error.response?.data?.message);
      });
  };

  return (
    <Layout ac2="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              <h5>Add Admin</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to={"/manage"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/manage-admin" state={{ id: id }}>
                    Admin List
                  </Link>
                </li>
                <li className="breadcrumb-item">Add Admin</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="input-group mb-3">
                  <select
                    className="form-control"
                    style={{ cursor: "pointer" }}
                    required
                    id="mandalSelect"
                    value={selectedMandal}
                    onChange={handleSelectChange}
                  >
                    <option value="" disabled selected>
                      Select Mandal
                    </option>
                    {mandals.map((mandal) => (
                      <option key={mandal.id} value={mandal.id}>
                        {mandal.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="adminFirstName">First Name</label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="adminFirstName"
                        placeholder="Enter admin First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="adminLastName">Last Name</label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="adminLastName"
                        placeholder="Enter admin Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="adminPhone">Phone</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="adminPhone"
                        placeholder="Enter admin Phone Number"
                        value={phone}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone(value);
                          }
                        }}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="adminPhone1">Phone 1</label>
                      <input
                        type="text"
                        className="form-control"
                        id="adminPhone1"
                        placeholder="Enter admin Phone Number"
                        value={phone1}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone1(value);
                          }
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="adminPhone2">Phone 2</label>
                      <input
                        type="text"
                        className="form-control"
                        id="adminPhone2"
                        placeholder="Enter admin Phone Number"
                        value={phone2}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone2(value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="adminUsername">Username</label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="adminUsername"
                        placeholder="Enter admin Username"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="adminPassword">Password</label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="adminPassword"
                        placeholder="Enter admin Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="photoUpload">Photo</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="photoUpload"
                            onChange={handleImageChange}
                            accept="image/*" // Accepted file types
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="photoUpload"
                          >
                            Choose file (417 X 530 - 1MB)
                          </label>
                        </div>
                        <div className="input-group-append d-none d-md-block">
                          <span className="input-group-text">Upload</span>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      {imagePreview && (
                        <div>
                          <label className="mr-3">Preview: </label>
                          <img
                            src={imagePreview}
                            alt="Selected file preview"
                            style={{ maxHeight: "100px", maxWidth: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="adminAddress">Address</label>{" "}
                      <span className="text-danger">*</span>
                      <textarea
                        type="text"
                        className="form-control"
                        id="adminAddress"
                        placeholder="Enter admin Address"
                        value={address}
                        rows="1"
                        onChange={(e) => setAddress(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="adminEmail">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="adminEmail"
                        placeholder="Enter admin Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-primary mx-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loaded}
                    >
                      {loaded ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </Layout>
  );
}

export default AddAdmin;
